<!-- Plan creation form -->
<form [formGroup]="form" (ngSubmit)="createNew()">
  <div>
    <label for="fee">Fee:</label>
    <input type="number" id="fee" formControlName="fee">
  </div>
  <div>
    <label for="percentageFee">Percentage Fee:</label>
    <input type="number" id="percentageFee" formControlName="percentageFee">
  </div>
  <div>
    <label for="customerId">Customer:</label>
    <select formControlName="customerId">
      <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
    </select>
  </div>
  <div>
    <label for="planName">Plan Name:</label>
    <input type="text" id="planName" formControlName="planName">
  </div>
  <button type="submit">Create Plan</button>
</form>
<div *ngIf="id">Created Plan ID: {{ id }}</div>

<!-- Show all plans toggle -->
<button (click)="toggleShowPlans()">
  {{showPlans ? 'Hide Plans' : 'Show All Plans'}}
</button>

<!-- Table shows all plans with controls for update and delete -->
<table *ngIf="showPlans">
  <thead>
    <tr>
      <th>ID</th>
      <th>Name</th>
      <th>Fee</th>
      <th>Percentage Fee</th>
      <th>Customer ID</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let plan of plans; let i = index">
      <td>{{plan.id}}</td>
      <td>
        <input *ngIf="plan.isEditing" type="text" [(ngModel)]="plan.planName">
        <span *ngIf="!plan.isEditing">{{plan.planName}}</span>
      </td>
      <td>
        <input *ngIf="plan.isEditing" type="number" [(ngModel)]="plan.fee">
        <span *ngIf="!plan.isEditing">{{plan.fee}}</span>
      </td>
      <td>
        <input *ngIf="plan.isEditing" type="number" [(ngModel)]="plan.percentageFee">
        <span *ngIf="!plan.isEditing">{{plan.percentageFee}}</span>
      </td>
      <td>
        <select *ngIf="plan.isEditing" [(ngModel)]="plan.customerId">
          <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
        </select>
        <span *ngIf="!plan.isEditing">{{plan.customerId}}</span>
      </td>
      <td>
        <button *ngIf="!plan.isEditing" (click)="editPlan(plan)">Edit</button>
        <button *ngIf="plan.isEditing" (click)="updatePlan(plan)">Save</button>
        <button *ngIf="plan.isEditing" (click)="cancelEditing(plan)">Cancel</button>
        <button (click)="deletePlan(plan.id)">Delete</button>
      </td>
    </tr>
  </tbody>
</table>